import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'

/**
 * An example element.
 *
 * @slot - This element has a slot
 * @csspart button - The button
 */
@customElement('tfp-page')
export class TFPPage extends LitElement {

  /**
   * The number of times the button has been clicked.
   */
  @property({ type: Number })
  count = 0

  render() {
    return html`
    <slot></slot>
    `
  }

  static styles = css`
    :host {
      max-width: var(--tfp-layout-max-width);
      margin: 0 auto;
      text-align: center;
      display: block;
      grid-template-rows: minmax(0, 1fr);
      width: 100%;
      height: 100%;
      overflow-y: auto;
    }

    ::slotted(h1) {
      font-size: 3.2em;
      line-height: 1.1;
    }

  `
}

declare global {
  interface HTMLElementTagNameMap {
    'tfp-page': TFPPage
  }
}
